<template>
  <!-- Map View -->
  <div class="c-outages-container">
    <div v-if="outagePageView === 'map'" class="c-outages-container__mapview">
      <div class="c-outages-container__mapview-wrapper">
        <div class="c-outages-container__mapview-outages">
          <outage-search></outage-search>
          <outages-results
            class="c-outages-container__mapview-results"
          ></outages-results>
        </div>
        <div class="c-outages-container__mapview-map">
          <outages-map></outages-map>
          <div class="c-outages-container__mapview-map-legend">
            <div class="c-outages-container__mapview-map-legend-outage">
              <img
                class="c-outages-container__mapview-map-legend-icon"
                src="_resources/app/client/assets/icons/outages-map/unplanned-outage-icon.svg"
              />
              <h3 class="c-outages-container__mapview-map-legend-text">
                Unplanned outage
              </h3>
            </div>
            <div class="c-outages-container__mapview-map-legend-outage">
              <img
                class="c-outages-container__mapview-map-legend-icon"
                src="_resources/app/client/assets/icons/outages-map/planned-outage-icon.svg"
              />
              <h3 class="c-outages-container__mapview-map-legend-text">
                Planned outage
              </h3>
            </div>
          </div>
        </div>
        <outages-messages></outages-messages>
      </div>
    </div>
    <!-- List View -->
    <div v-else class="c-outages-container__listview">
      <outage-search></outage-search>
      <div class="c-outages-container__listview-results-wrapper">
        <div class="c-outages-container__listview-results">
          <outages-results></outages-results>
        </div>
        <div class="c-outages-container__listview-sidebar">
          <outages-footer></outages-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";

import OutageSearch from "./OutageSearch.vue";
import OutagesResults from "./OutagesResults.vue";
import OutagesMap from "./OutagesMap.vue";
import OutagesFooter from "./OutagesFooter.vue";
import OutagesMessages from "./OutagesMessages.vue";

export default {
  created() {},
  components: {
    OutageSearch,
    OutagesResults,
    OutagesMap,
    OutagesFooter,
    OutagesMessages,
  },
  mounted() {},
  computed: {
    ...mapFields(["outagePageView"]),
    ...mapGetters(["getMarkerIcon"]),
  },
  methods: {},
};
</script>

<style lang="scss"></style>
